import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import analyticsLogger from '../middleware/analyticsLogger';
import locationMiddleware from '../middleware/location';
import rootReducer from '../reducers';

export default function configureStore(initialState = {}, sagasMiddlewares = []) {
  const sagaMiddleware = createSagaMiddleware();

  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && !process.env.BUILD
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          name: 'LastMinuteSales',
          trace: true,
          traceLimit: 25,
        })
      : compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware, locationMiddleware, analyticsLogger)),
  );

  sagasMiddlewares.forEach((saga) => sagaMiddleware.run(saga));

  return store;
}
